import commonjs from './common.js'
export default {
    //app user
    appUserCreate: {
        userName: [
            { required: true, message: 'User Name cannot be empty' },
            { min: 8, message: 'User Name must be 8-15 chars' },
            { max: 15, message: 'User Name must be 8-15 chars' }
        ],
        lastName: [
            { required: true, message: 'Last Name cannot be empty' },
        ],
        dob: [
            { required: true, message: 'Date of Birth cannot be empty' },
        ],
        salesOffice: [
            { required: true, message: 'Sales Office cannot be empty' },
        ],
        region: [
            { required: true, message: 'Region cannot be empty' },
        ],
        representativeName: [
            { required: true, message: 'Sales Representative Name cannot be empty' },
        ],
        email: [
            { type: 'email', message: 'Please enter the correct format', trigger: ['blur', 'change'] }
        ],
        userType: [
            { required: true, message: 'User Type cannot be empty' },
        ],
        password: [
            { required: true, message: 'Password cannot be empty' },
            { validator: commonjs.pwdValidator }
        ],
    },
    appUserEdit: {
        userName: [
            { required: true, message: 'User Name cannot be empty' },
            { min: 8, message: 'User Name must be 8-15 chars' },
            { max: 15, message: 'User Name must be 8-15 chars' }
        ],
        dob: [
            { required: true, message: 'Date of Birth cannot be empty' },
        ],
        lastName: [
            { required: true, message: 'Last Name cannot be empty' },
        ],
        salesOffice: [
            { required: true, message: 'Sales Office cannot be empty' },
        ],
        region: [
            { required: true, message: 'Region cannot be empty' },
        ],
        representativeName: [
            { required: true, message: 'Sales Representative Name cannot be empty' },
        ],
        salesforceLanguage: [
            { required: true, message: 'Salesforce Language cannot be empty' },
        ],
        email: [
            { type: 'email', message: 'Please enter the correct format', trigger: ['blur', 'change'] }
        ]
    },
    //cms user
    cmsUserCreate: {
        userLevel: [
            { required: true, message: 'User Type cannot be empty' },
        ],
        salesOffice: [
            { required: true, message: 'Sales Office cannot be empty' },
        ],
        regions: [
            { required: true, message: 'Region cannot be empty' },
        ],
        name: [
            { required: true, message: 'Name cannot be empty' },
        ],

        employeId: [
            { required: true, message: 'employeId cannot be empty' },
        ],

        // firstName:[
        //     {required:true,message:'First Name cannot be empty'},
        // ],
        // lastName:[
        //     {required:true,message:'Last Name cannot be empty'},
        // ],
        initial: [
            { required: true, message: 'Initial cannot be empty' },
        ],
        email: [
            { required: true, message: 'Email cannot be empty' },
            { type: 'email', message: 'Please enter the correct format', trigger: ['blur', 'change'] }
        ],
        pwd: [
            { required: true, message: 'Password cannot be empty' },
            { validator: commonjs.pwdValidator }
        ],
    },
    cmsUserEdit: {
        userLevel: [
            { required: true, message: 'User Type cannot be empty' },
        ],
        salesOffice: [
            { required: true, message: 'Sales Office cannot be empty' },
        ],
        regions: [
            { required: true, message: 'Region cannot be empty' },
        ],
        Name: [
            { required: true, message: 'Name cannot be empty' },
        ],
        initial: [
            { required: true, message: 'Initial cannot be empty' },
        ],
    },
    //hotline
    hotlineCreate: {
        country: [
            { required: true, message: 'Country / Region cannot be empty' },
        ],
        tel: [
            { required: true, message: 'Tel Number cannot be empty' },
            { validator: commonjs.telValidator }
        ],
        order: [
            { required: true, message: 'Order cannot be empty' },
            { validator: commonjs.orderValidator }
        ],
        post: [
            { required: true, message: 'Post cannot be empty' },
        ]
    },
    //location
    locationCreate: {
        country: [
            { required: true, message: 'Country / Region cannot be empty' },
        ],
        cityEn: [
            { required: true, message: 'Office Name / City (EN) cannot be empty' },
        ],
        cityJp: [
            { required: true, message: 'Office Name / City (JP) cannot be empty' },
        ],
        cityTc: [
            { required: true, message: 'Office Name / City (TC) cannot be empty' },
        ],
        citySc: [
            { required: true, message: 'Office Name / City (SC) cannot be empty' },
        ],
        addressEn: [
            { required: true, message: 'Project address (EN) cannot be empty' },
        ],
        addressJp: [
            { required: true, message: 'Project address (JP) cannot be empty' },
        ],
        addressTc: [
            { required: true, message: 'Project address (TC) cannot be empty' },
        ],
        addressSc: [
            { required: true, message: 'Project address (SC) cannot be empty' },
        ],
        order: [
            { required: true, message: 'Order cannot be empty' },
            { validator: commonjs.orderValidator }
        ],
        post: [
            { required: true, message: 'Post cannot be empty' },
        ]
    },
    //product
    productCreate(fun1, fun2) {
        return {
            salesOffice: [
                { required: true, message: 'Sales Office cannot be empty' },
            ],
            region: [
                { required: true, message: 'Region cannot be empty' },
            ],
            language: [
                { required: true, message: 'Supported Languages cannot be empty' },
            ],
            projectType: [
                { required: true, message: 'Project Type cannot be empty' },
            ],
            propertySize: [
                { required: false, message: 'Property Size cannot be empty' },
                { validator: commonjs.propertySizeValidator }
            ],
            images: [
                { required: true, message: 'Images cannot be empty' },
            ],
            thumbnail: [
                { required: true, message: 'Thumbnail cannot be empty' },
            ],
            amounts: [
                { required: true, message: 'Minimal Investment Amount cannot be empty' },
                { validator: commonjs.amountsValidator }
            ],
            syndicationPrice: [
                { required: false },
                { validator: commonjs.syndicationPriceValidator }
            ],
            project_Status: [
                { required: true, message: 'Project Status cannot be empty' },
            ],
            projectRegion: [
                { required: true, message: 'Project Region cannot be empty' },
            ],
            onlineTimeS: [
                { required: true, message: 'Online timeframe (Start) cannot be empty' },
                { validator: fun1 }
            ],
            onlineTimeE: [
                { required: true, message: 'Online timeframe (End) cannot be empty' },
                { validator: fun2 }
            ]
        }
    },
    productEdit(fun1, fun2) {
        return {
            region: [
                { required: true, message: 'Region cannot be empty' },
            ],
            language: [
                { required: true, message: 'Supported Languages cannot be empty' },
            ],
            projectType: [
                { required: true, message: 'Project Type cannot be empty' },
            ],
            propertySize: [
                { required: false, message: 'Property Size cannot be empty' },
                { validator: commonjs.propertySizeValidator }
            ],
            images: [
                { required: true, message: 'Images cannot be empty' },
            ],
            thumbnail: [
                { required: true, message: 'Thumbnail cannot be empty' },
            ],
            amounts: [
                { required: true, message: 'Minimal Investment Amount cannot be empty' },
                { validator: commonjs.amountsValidator }
            ],
            syndicationPrice: [
                { required: false },
                { validator: commonjs.syndicationPriceValidator }
            ],
            project_Status: [
                { required: true, message: 'Project Status cannot be empty' },
            ],
            projectRegion: [
                { required: true, message: 'Project Region cannot be empty' },
            ],
            onlineTimeS: [
                { required: true, message: 'Online timeframe (Start) cannot be empty' },
                { validator: fun1 }
            ],
            onlineTimeE: [
                { required: true, message: 'Online timeframe (End) cannot be empty' },
                { validator: fun2 }
            ]
        }
    },
    //notificaition
    pushCreate(fun1) {
        return {
            salesOffice: [
                { required: true, message: 'Sales Office cannot be empty' },
            ],
            region: [
                { required: true, message: 'Region cannot be empty' },
                { validator: fun1 }
            ],
            notificationType: [
                { required: true, message: 'Notification Type cannot be empty' },
            ],
            titleEn: [
                { required: true, message: 'Title (EN) cannot be empty' },
            ],
            titleJp: [
                { required: true, message: 'Title (JP) cannot be empty' },
            ],
            titleTc: [
                { required: true, message: 'Title (TC) cannot be empty' },
            ],
            titleSc: [
                { required: true, message: 'Title (SC) cannot be empty' },
            ],
            // summaryEn:[
            //     {required:true,message:'Summary (EN) cannot be empty'},
            // ],
            // summaryJp:[
            //     {required:true,message:'Summary (JP) cannot be empty'},
            // ],
            // summaryTc:[
            //     {required:true,message:'Summary (TC) cannot be empty'},
            // ],
            // summarySc:[
            //     {required:true,message:'Summary (SC) cannot be empty'},
            // ],
            contentEn: [
                { required: true, message: 'Inbox Content (EN) cannot be empty' },
                commonjs.contentMaxLengthValidator('EN', 3500),
            ],
            contentJp: [
                { required: true, message: 'Inbox Content (JP) cannot be empty' },
                commonjs.contentMaxLengthValidator('JP', 3500),
            ],
            contentTc: [
                { required: true, message: 'Inbox Content (TC) cannot be empty' },
                commonjs.contentMaxLengthValidator('TC', 3500),
            ],
            contentSc: [
                { required: true, message: 'Inbox Content (SC) cannot be empty' },
                commonjs.contentMaxLengthValidator('SC', 3500),
            ],
            deliveryDate: [
                { required: true, message: 'Delivery Date & Time cannot be empty' },
                { validator: commonjs.deliveryDateValidator }
            ],
            csvFile: [
                { required: true, message: 'Client list (CSV file) cannot be empty' },
            ],
            notificationCategory: [
                { required: true, message: 'Notification Category cannot be empty' },
            ]
        }
    },
    pushEdit: {
        salesOffice: [
            { required: true, message: 'Sales Office cannot be empty' },
        ],
        region: [
            { required: true, message: 'Region cannot be empty' },
        ],
        notificationType: [
            { required: true, message: 'Notification Type cannot be empty' },
        ],
        titleEn: [
            { required: true, message: 'Title (EN) cannot be empty' },
        ],
        titleJp: [
            { required: true, message: 'Title (JP) cannot be empty' },
        ],
        titleTc: [
            { required: true, message: 'Title (TC) cannot be empty' },
        ],
        titleSc: [
            { required: true, message: 'Title (SC) cannot be empty' },
        ],
        // summaryEn:[
        //     {required:true,message:'Summary (EN) cannot be empty'},
        // ],
        // summaryJp:[
        //     {required:true,message:'Summary (JP) cannot be empty'},
        // ],
        // summaryTc:[
        //     {required:true,message:'Summary (TC) cannot be empty'},
        // ],
        // summarySc:[
        //     {required:true,message:'Summary (SC) cannot be empty'},
        // ],
        contentEn: [
            { required: true, message: 'Inbox Content (EN) cannot be empty' },
            commonjs.contentMaxLengthValidator('EN', 3500),
        ],
        contentJp: [
            { required: true, message: 'Inbox Content (JP) cannot be empty' },
            commonjs.contentMaxLengthValidator('JP', 3500),
        ],
        contentTc: [
            { required: true, message: 'Inbox Content (TC) cannot be empty' },
            commonjs.contentMaxLengthValidator('TC', 3500),
        ],
        contentSc: [
            { required: true, message: 'Inbox Content (SC) cannot be empty' },
            commonjs.contentMaxLengthValidator('SC', 3500),
        ],
        csvFile: [
            { required: true, message: 'Client list (CSV file) cannot be empty' },
        ],
        notificationCategory: [
            { required: true, message: 'Notification Category cannot be empty' },
        ]
    },
    //notificaition
    genericContentCreate: {
        field: [
            { required: true, message: 'Field cannot be empty' },
        ],
        type: [
            { required: true, message: 'Type cannot be empty' }
        ],
        contentEn: [
            { required: true, message: 'Content (EN) cannot be empty' },
        ]
    }
}


// WEBPACK FOOTER //
// ./src/script/validation.js